// assets
import { IconReport } from '@tabler/icons';
import prtChild from './PrtChild';

// constant
const icons = { IconReport };

const partnerCol = {
    id: `partnerCol-${Math.random()}`,
    title: 'Partner Profile',
    type: 'collapse',
    // url: `/dashboard/default`,
    icon: icons.IconReport,
    breadcrumbs: false,
    children: prtChild,
    role: process.env.REACT_APP_RL_PRTPRFCOL
};

export default partnerCol;